import React from 'react';

import { useOutstandingResponsesReportCsv } from 'api';
import { useOutstandingResponseFilters } from './hooks';
import { MobileReportModal } from '../..';

export const OutstandingResponsesReportMobile: React.FC = () => {
  const filters = useOutstandingResponseFilters();
  const { mutate: exportCsv } = useOutstandingResponsesReportCsv();

  return <MobileReportModal filters={filters} exportCsv={exportCsv} />;
};
